import gql from 'graphql-tag';
import Address from './Address';
import Member from './Member';
import CremationManagerAddressBook from './AddressBook';

export default gql`
	fragment DispatchDate on CMCremationDispatchDate {
		ID
		Date
		Time
		ContainmentStyle
		Ashes
		DispatchMethod
		AshesCollectedBy
		Comment
		DispatchComplete
		FuneralDirector
		DestinationAddress {
			...Address
		}
		AssignedStaff {
			...Member
		}
		Supplier {
			...CremationManagerAddressBook
		}
	}
	${Address}
	${CremationManagerAddressBook}
	${Member}
`;
